import styled from 'styled-components';

export default styled.div`
  width: 1.1rem;
  height: 1.1rem;
  vertical-align: -0.5rem;
`;
